module.exports = __webpack_public_path__ + "la.5166ae5f2601cd29f55f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/la.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/la.svg
// module chunks = styles